import {useEffect} from 'react';
import {selectChannelData} from '../store/slices/channel/slice';
import {selectEnvironment} from '../store/slices/config/slice';
import {selectVenueId} from '../store/slices/venue/slice';
import {
  availabilityPageType,
  createPageData,
  reschedulePageType,
} from '../utils/generatePageTracking';
import {useAppSelector} from './store';

export const useTrackPageData = (
  pageType: typeof availabilityPageType | typeof reschedulePageType,
) => {
  const channel = useAppSelector(selectChannelData);
  const environment = useAppSelector(selectEnvironment);
  const venueId = useAppSelector(selectVenueId);

  useEffect(() => {
    const pageTrackingData = createPageData({
      channel,
      environment,
      venueId,
      pageType,
    });
    window.dataLayer.push(pageTrackingData);
  }, [channel, environment, venueId, pageType]);
};
